export const FETCH_FREE_PRODUCTS_LOADING = 'FETCH_FREE_PRODUCTS_LOADING';
export const FETCH_FREE_PRODUCTS_SUCCESS = 'FETCH_FREE_PRODUCTS_SUCCESS';
export const FETCH_FREE_PRODUCTS_ERROR = 'FETCH_FREE_PRODUCTS_ERROR';
